import React from 'react';
import { useLocalStorage } from 'react-haiku';
import classnames from 'classnames';

import { useAppStore } from 'store/useAppStore';
import Icon from 'components/Misc/Icon';

const Theme = () => {
	// User app's store
	const theme = useAppStore(state => state.theme);

	// Use local storage
	const [, setStorageTheme] = useLocalStorage('theme');

	// Concat classnames
	const circleClassName = classnames(
		'absolute w-7 h-7 bg-amber-500 rounded-full transition-all select-none cursor-pointer',
		theme === 'light' && 'left-1',
		theme === 'dark' && 'right-1'
	);

	// Concat classnames
	const lightClassName = classnames(
		'mr-4 relative z-10 w-7 h-7 leading-7 text-center select-none cursor-pointer',
		theme === 'light' && 'text-white',
		theme !== 'light' && 'text-neutral-500 dark:text-neutral-400'
	);

	// Concat classnames
	const darkClassName = classnames(
		'relative z-10 w-7 h-7 leading-7 text-center select-none cursor-pointer',
		theme === 'dark' && 'text-white',
		theme !== 'dark' && 'text-neutral-500 dark:text-neutral-400'
	);

	// Toggle between light and dark theme
	const toggleTheme = () => setStorageTheme(theme === 'dark' ? 'light' : 'dark');

	return (
		<div className="ml-4 mb-4 relative p-1 inline-flex bg-neutral-100 dark:bg-neutral-700 rounded-full cursor-pointer" onClick={toggleTheme}>
			<div className={circleClassName} />
			<Icon icon="wb_sunny" className={lightClassName} />
			<Icon icon="brightness_2" className={darkClassName} />
		</div>
	);
};

export default Theme;